export const ReactionName = Object.freeze({
	like: 'like',
	faceWithTearsOfJoy: 'faceWithTearsOfJoy',
	redHeart: 'redHeart',
	neutralFace: 'neutralFace',
	fire: 'fire',
	cry: 'cry',
	slightlySmilingFace: 'slightlySmilingFace',
	handshake: 'handshake',
	hundredPoints: 'hundredPoints',
	sleepingSymbol: 'sleepingSymbol',
	crossMark: 'crossMark',
	whiteHeavyCheckMark: 'whiteHeavyCheckMark',
	eyes: 'eyes',
	winkingFace: 'winkingFace',
	laugh: 'laugh',
	kiss: 'kiss',
	wonder: 'wonder',
	slightlyFrowningFace: 'slightlyFrowningFace',
	loudlyCryingFace: 'loudlyCryingFace',
	faceWithStuckOutTongue: 'faceWithStuckOutTongue',
	faceWithStuckOutTongueAndWinkingEye: 'faceWithStuckOutTongueAndWinkingEye',
	smilingFaceWithSunglasses: 'smilingFaceWithSunglasses',
	confusedFace: 'confusedFace',
	flushedFace: 'flushedFace',
	thinkingFace: 'thinkingFace',
	angry: 'angry',
	smilingFaceWithHorns: 'smilingFaceWithHorns',
	faceWithThermometer: 'faceWithThermometer',
	facepalm: 'facepalm',
	poo: 'poo',
	flexedBiceps: 'flexedBiceps',
	clappingHands: 'clappingHands',
	raisedHand: 'raisedHand',
	dislike: 'dislike',
	smilingFaceWithHeartEyes: 'smilingFaceWithHeartEyes',
	smilingFaceWithHearts: 'smilingFaceWithHearts',
	pleadingFace: 'pleadingFace',
	relievedFace: 'relievedFace',
	foldedHands: 'foldedHands',
	okHand: 'okHand',
	signHorns: 'signHorns',
	loveYouGesture: 'loveYouGesture',
	clownFace: 'clownFace',
	partyingFace: 'partyingFace',
	questionMark: 'questionMark',
	exclamationMark: 'exclamationMark',
	lightBulb: 'lightBulb',
	bomb: 'bomb',
});
